<div *ngIf="util.checkJPContry()" class="form-group" [ngClass]="{'mt-1 mb-0': flag === ''}">
    <label [ngClass]="{'w110': flag === '', 'w140': flag === '1'}" [title]="translate.instant('STR_DATEOFBIRTH')">{{'STR_DATEOFBIRTH'| translate}}</label>
    <div class="multi-select mr-10" [ngClass]="{'w60': flag === '', 'w80': flag === '1'}" (mouseleave)="showDropDown && outSelectValue()">
        <input  type="text" class="drop-toggle btn flat inp-select-focus" 
                [(ngModel)]="selectedYear" 
                (click)="showDropDown=!showDropDown" 
                [ngClass]="{'active': showDropDown}"
                [readonly]='true'
                [disabled]="setReadonly">
        <div class="drop-show" [ngClass]="{'scroll-box': lstYear.length >=20}" *ngIf="showDropDown">
            <div *ngFor="let it of lstYear; index as i">
                <label (click)="selected(it)" [ngClass]="{'active': it.active}">
                    {{it.value}}
                </label>
            </div>
        </div>
    </div>
    <div class="form-calendar w120 mr-10">
        <input type="text" [(ngModel)]="dateOfBirth" [placeholder]="placeHolder" [disabled]="setReadonly" numberForm [maxlength]="formMaxLength" (blur)="onFocusOut()"
        (focus)="onFocusIn()" class=" form-control">
    </div>
    <div class="text-view p-0" [ngClass]="{'mr-10': flag === '1'}">{{labelYear}}</div>
</div>
<div *ngIf="!util.checkJPContry()" class="form-group mt-1 mb-0">
    <label class="w110" [title]="translate.instant('STR_DATEOFBIRTH')">{{'STR_DATEOFBIRTH'| translate}}</label>
    <div class="form-calendar w140">
        <input [dateFormat]="DoBDay" (eventBlurOutput)="FocusOutDate($event, true)" type="text" class="form-control-calendar form-control"
            bsDatepicker maxlength="8"
            #dobDatepicker="bsDatepicker"
            [(bsValue)]="DoBDay">
        <span class="date-icon" (click)="dobDatepicker.toggle()"></span>
    </div>
</div>
<div class="form-group mt-1 mb-0">
    <label class="w60" [ngClass]="{'mr-10': util.checkJPContry()}" [title]="translate.instant('STR_AGE')">{{'STR_AGE'| translate}}</label>
    <div class="text-view" [title]="translate.instant('STR_AGE2')">{{ageTxt}}{{'STR_AGE2'| translate}}</div>
</div>



